<template>
    <div :style="`background:rgba(${olorRgb(bgColor)},${opacity})`" class="nav-bar" style="color:gray">
        <div :style="`height:${statusBarHeight}px`" class="status"></div>
        <div class="bar">
            <slot></slot>
        </div>
    </div>
</template>

<script>
// header navBar
export default {
    props: {
        bgColor: {
            type: String,
            default: '#fff'
        },
        maxOpacity: {
            type: Number,
            default: 1
        },
        fontColor: {
            type: String,
        },
        defaultOpacity: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            opacity: 0,
        }
    },
    computed: {
        statusBarHeight() {
            return this.$store.state.user.statusBarHeight
        }
    },
    created() {
    },
    activated() {
        window.addEventListener("scroll", this.watchScroll);
    },
    deactivated() {
        window.removeEventListener('scroll', this.watchScroll);
    },
    // destroyed() {
    //     window.removeEventListener('scroll', this.watchScroll);
    // },
    methods: {
        watchScroll() {
            //获取当前页面的滚动条纵坐标位置      网页被卷去的高
            const top = document.documentElement.scrollTop || document.body.scrollTop
            let opacity = top / 400;
            this.$emit('change', opacity)
            opacity = opacity > this.maxOpacity ? this.maxOpacity : opacity;
            this.opacity = opacity;
            this.$emit('watchScroll', document.documentElement.scrollTop)
        },
        //十六进制转rgba
        olorRgb(color) {
            let reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
            let sColor = color.toLowerCase();
            if (sColor && reg.test(sColor)) {
                if (sColor.length === 4) {
                    let sColorNew = "#";
                    for (let i = 1; i < 4; i += 1) {
                        sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1));
                    }
                    sColor = sColorNew;
                }
                //处理六位的颜色值
                let sColorChange = [];
                for (let i = 1; i < 7; i += 2) {
                    sColorChange.push(parseInt("0x" + sColor.slice(i, i + 2)));
                }
                return sColorChange.join(",")
            } else {
                return '255,255,255';
            }
        },
        //父组件需要在销毁是销毁监听事件
        destruction() {
            //销毁监听滚动事件
            window.removeEventListener('scroll', this.watchScroll);
        },
        beforeDestroy() {
            window.removeEventListener('scroll', this.watchScroll);
        }
    },

}
</script>

<style lang="scss" scoped>
@function px2rem($px) {
    @return ($px / 20) * 1rem * 0.5;
}

.nav-bar {
    position: fixed;
    z-index: 50;
    top: 0;
    left: 0;
    width: 100vw;
    // height: px2rem(140);
    .bar {
        height: 10.333vw;
        display: flex;
        align-items: center;
        // font-size: px2rem(40);
        font-size: pxvw(32);
    }
}
</style>
